// gatsby-browser.jsとgatsby-ssr.js
import React from 'react';
import { PlayerProvider } from './src/contexts/PlayerContext';
import Layout from './src/components/layout';
import "@fortawesome/fontawesome-svg-core/styles.css";
import './src/styles/global.css'

export const wrapPageElement = ({ element }) => (
  <PlayerProvider>
    <Layout>
      {element}
    </Layout>
  </PlayerProvider>
);

